/**
 * Getters de eventos
 */
export const getNotifications = (state) => {
  return state.notifications;
};

export const getEvents = (state) => {
  return state.events;
};
